import ElectricInputForm from "../offices/ElectricInputForm";

import { useElectricityInputProps } from "../../../helpers/components/inputs";

const useElectrictyInput = ({ transaction, onSave }) => {
  const { status } = transaction;
  const {
    electricKwh,
    setElectricKwh,
    electricRenewablesAndIntensityInputFormProps,
    electricCarbonTons,
    saveEnabled,
    saveObject,
  } = useElectricityInputProps(transaction);

  const inputBlock = (
    <ElectricInputForm
      electricKwh={electricKwh}
      setElectricKwh={setElectricKwh}
      {...electricRenewablesAndIntensityInputFormProps}
      disabled={status === "locked"}
    />
  );

  const onTransactionSave = () =>
    onSave({
      tonsCo2e: electricCarbonTons,
      emissionData: saveObject.emissionData,
    });

  return {
    inputBlock,
    onTransactionSave,
    saveEnabled: saveEnabled,
    tonsCo2e: electricCarbonTons,
  };
};
export default useElectrictyInput;
